import React from "react";
import { connect } from "react-redux";
import { withStat } from "redux/selectors";
import App from "../components";
import Tabs from "./Tabs";
import styled, { css } from "styled-components";
import FullLoader from 'components/FullLoader'

const StyledWrapper = styled.div`
  ${props => css`
    ${props.theme.Wrapper};
  `};
`;

const Stat = ({ errors, list, total, isFetching }) => (
  <StyledWrapper>
    {isFetching && <FullLoader />}
    <Tabs/>
    <App total={total} items={list} />
  </StyledWrapper>
);

const mapStateToProps = state => {
  const {
    stat: { type: { total: { main: { isFetching, errors, total } } } }
  } = state;

  const list = withStat(state);
  return {
    errors,
    list,
    total,
    isFetching
  };
};

export default connect(mapStateToProps)(Stat);
